import type { BoardSample } from "@/lib/timeline/board";
import type { PlaybackState } from "@/lib/timeline/playback";

export interface TimelineFrameDetail {
  playback: PlaybackState;
  boardSample?: BoardSample;
  viewportWidth?: number;
}

export function timelineFrameDetail(event: Event): TimelineFrameDetail | null {
  if (!(event instanceof CustomEvent)) {
    return null;
  }
  const detail = event.detail as TimelineFrameDetail | null | undefined;
  if (
    detail === undefined
    || detail === null
    || typeof detail.playback !== "object"
  ) {
    return null;
  }
  return detail;
}
